import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/arrow/core_back.webp";

function Corearrow() {
  return (
    <section
      className="core_arrow text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="mt-auto text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/arrow/core_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={689}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>The Core Purpose of Arrow Recovery</h2>
            <p>
              Catalytic converters are a niche commodity and the absence of an
              integrated marketplace where they can be sold, bought or evaluated
              made it incredibly difficult for people to engage in it’s trade.
            </p>
            <p>
              Arrow Recovery served as the platform that meets this important
              need by providing users with a marketplace that’s complete with
              all the important features.
            </p>
            <p>
              On this platform, you can ask for quotes on used catalytic
              converters, search and acquire new and used catalytic converters,
              complete a full trade transaction with cost estimates and
              delivery. The platform also shares live market rates of catalytic
              converters and key products related to it in order to keep the
              ongoing trade relevant to existing market prices. This powers
              maximum ease and satisfaction among users that own or want to
              trade their catalytic converters.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Corearrow;
